module.exports = __webpack_public_path__ + "static/media/20.d7a5fe99.jpg";